<template>
	<div class="home-box">
		<!-- 个人信息 -->
		<UserHeaderInformation :Information_user_id="Information_user_id" :parent_type="activeMenu" @operations="operations"></UserHeaderInformation>
	 
		<!-- 顶部菜单 -->
		<div class="menu-bar">
			<button v-for="menu in menus" :key="menu.key" :class="{ active: activeMenu === menu.key }" @click="setActiveMenu(menu, 'click')">
				<h2 class="button_text">{{ menu.name }}</h2>
			</button>
		</div>
	 
		<!-- <PostingModule></PostingModule> -->

		<!-- 内容显示 -->
		<div class="content-box">
			<div v-if="activeMenu === 'Posts'" class="Posts-content">
				<PostList ref="PostListRef" :Post_List="Posts_list" :Loading="Loading" :parent_type="activeMenu" :page_name="page_name" @operations="operations"></PostList>
				<Pagination class="postPagination" v-show="total_num_Posts > 0" :per_page.sync="page_Posts.per_page" :page-sizes="pageSizes" :page.sync="page_Posts.page" :total="total_num_Posts" @pagination="get_page_Data_Posts" ></Pagination>
			</div>
			<div v-if="activeMenu === 'Media'" class="Media-content">
				<PostList :Post_List="Media_list" :Loading="Loading" :parent_type="activeMenu" :page_name="page_name" @operations="operations"></PostList>
				<Pagination class="postPagination" v-show="total_num_Media > 0" :per_page.sync="page_Media.per_page" :page-sizes="pageSizes" :page.sync="page_Media.page" :total="total_num_Media" @pagination="get_page_Data_Media" ></Pagination>
			</div>
		</div>
	</div>
</template>

<script>
import UserHeaderInformation from '../components/public/UserHeaderInformation.vue'
import PostingModule from '../components/public/PostingModule.vue'
import PostList from '../components/public/PostList.vue'
import Pagination from "@/components/Pagination"
import { post_community_userposts } from '@/api/community.js'

export default {
components: { PostingModule, PostList, UserHeaderInformation, Pagination },
  name: "user-profile",
  
  data() {
		return {
			menus: [
				{ key: "Posts", name: this.$t('PersonalArr.Posts'), post_type: 1, first: true },
				{ key: "Media", name: this.$t('PersonalArr.Media'), post_type: 2, first: true },
			],
			activeMenu: "", // 默认选中菜单 Posts
			currentMenu: "",
			page_name: "user-profile",
			Posts_list: [],
			Media_list: [],
			following_list: [],
			Information_user_id: this.$store.state.userinfo.user_id,
			search: {
				user_id: this.$store.state.userinfo.user_id,
				post_type: 1, //1图文, 2视频
			},
			page_Posts: {
				page: 1,
				per_page: 10,
			},
			page_Media: {
				page: 1,
				per_page: 10,
			},
			Loading: false,
			total_num_Posts: 0,
			total_num_Media: 0,
			last_page_Posts: 0,
			last_page_Media: 0,
			pageSizes: [10, 20, 30],
		};
	},
  
  
  // 监听
  watch: {
		"$store.state.userinfo": {
			handler: function (newValue, oldValue) {
				this.search.user_id = this.$store.state.userinfo.user_id
				this.Information_user_id = this.$store.state.userinfo.user_id
			},
			deep: true
		},
  	// "searchText": {
  	// 	handler: function (newValue, oldValue) {
  	// 		if(this.searchText && this.searchText != ''){
  	// 			this.icon_search = false
  	// 		}else{
  	// 			this.icon_search = true
  	// 		}
  	// 	},
  	// 	deep: true
  	// },
  },
  
	// 路由进入可操作数据
	beforeRouteEnter(to, from, next) {
		next()
	},
  
	// 路由进入可操作数据
	activated() {
		console.log('路由进来个人页面成功返回');
	
		this.search.user_id = this.$store.state.userinfo.user_id
		this.Information_user_id = this.$store.state.userinfo.user_id
		this.setActiveMenu(this.currentMenu ? this.currentMenu : this.menus[0])
	},
	
	// beforeCreate() {
  	
	// }
  
	created () {
  	
	},
    
	mounted() {
		this.setActiveMenu(this.currentMenu ? this.currentMenu : this.menus[0])
		// this.set_type_list()
	},
    
	methods: {
		
		// 更新激活的菜单
		setActiveMenu(menu, click) {
			if(this.activeMenu == menu.key && click == 'click'){ return }
			this.currentMenu = menu
			this.activeMenu = menu.key
			this.search.post_type = menu.post_type
			this.set_type_list(!menu.first ? 'HiddeLoading' : '')
			return menu.first = false
		},
		
		// 根据类型获取数据
		set_type_list(typeName){
			if(this.search.post_type == 1){
				this.get_data_list(this.page_Posts, typeName)
			}else{
				this.get_data_list(this.page_Media, typeName)
			}
		},
		
		// 获取分页 Posts
		get_page_Data_Posts(obj) {
			console.log(obj)
			if(obj && obj.page){
				this.page_Posts.page = obj.page
			}
			if(obj && obj.per_page){
				this.page_Posts.per_page = obj.per_page
			}
			this.get_data_list(this.page_Posts)
		},
		
		// 获取分页 Media
		get_page_Data_Media(obj) {
			console.log(obj)
			if(obj && obj.page){
				this.page_Media.page = obj.page
			}
			if(obj && obj.per_page){
				this.page_Media.per_page = obj.per_page
			}
			this.get_data_list(this.page_Media)
		},
		
		//获取列表
		get_data_list(pageObj, typeName){
			console.log(pageObj)
			if(!this.search.user_id){ return }
			if(this.Loading){ return }
			if(typeName != "HiddeLoading"){
				this.Loading = true
			}
			let obj = {
				user_id: this.search.user_id, 
				post_type: this.search.post_type, 
				page: pageObj.page,
				per_page: pageObj.per_page
			}
			console.log(obj)
			post_community_userposts(obj)
		   .then((res) => {
				console.log(res)
				this.Loading = false
				if(res.code == 0){
					this.data_processing(res)
				}else{
					this.exception_handling(res)
				}
				let path = this.$router.currentRoute.path
				this.$setTags.updateCanonical(`${path}?type=${obj.post_type}&page=${obj.page || 1}`)
				// this.$setTags.updateCanonical(`/user-profile?type=${obj.post_type}&page=${obj.page || 1}`)
		   })
		   .catch((err) => {
				console.log(err)
				this.exception_handling(err)
		   })
		},
		
		//数据处理
		data_processing(res){
			if(res && res.data){
				if(res.data.data){
					if(this.search.post_type == 1){
						this.Posts_list = res.data.data
						this.total_num_Posts = res.data.total ? res.data.total : 0
						this.last_page_Posts = res.data.last_page ? res.data.last_page : 0
						this.callGrandChildFun()
					}else{
						this.Media_list = res.data.data
						this.total_num_Media = res.data.total ? res.data.total : 0
						this.last_page__Media = res.data.last_page ? res.data.last_page : 0
					}
				}else{
					if(this.search.post_type == 1){
						this.Posts_list = []
						this.total_num_Posts = 0
						this.last_page_Posts = 0
					}else{
						this.Media_list = []
						this.total_num_Media = 0
						this.last_page_Posts = 0
					}
				}
			}
		},
		
		//异常处理
		exception_handling(err){
			this.list = []
			this.Loading = false
			this.$errorMessage(err)
			// this.$message('err.data.message', 'error')
		},
		
		//子组件关注操作 取消/关注/删除
		operations(type){
			if(type == 'success'){
				// 操作成功刷新列表数据
				this.set_type_list('HiddeLoading')
			}
		},
	
		// 调用孙子组件的方法
		callGrandChildFun() {
			// 获取子组件的实例
			const PostListRef = this.$refs.PostListRef;
			if (PostListRef && PostListRef.$children && PostListRef.$children.length !== 0) {
				let children = PostListRef.$children;
				
				children.forEach(item => {
					if (item.set_bg_color) { // 确保方法存在
						item.set_bg_color('again');
					} else {
						console.warn("子组件没有 set_bg_color 方法:", item);
					}
				});
			} else {
				console.error("未找到 PostListRef 的 ref 或 $children 为空");
			}
		},
  },
  
};
</script>

<style lang="less" scoped>
	*{
		box-sizing: border-box;
	}
	.Content-layout{
		background-color: transparent !important;
	}
	.home-box {
	  width: 100%;
	  max-width: 1280px;
	  margin: 0 auto;
	  background-color: transparent;
	}

	.menu-bar {
		margin-top: 10px;
	   display: flex;
	   justify-content: space-between;
	}

	.menu-bar button {
		border: none;
		font-size: 16px;
		cursor: pointer;
		color: #1E1E1E;
		font-weight: 600;
		width: calc(calc(100% - 10px) / 2);
		border-radius: 8px;
		background-color: #ffffff;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0px 10px;
	}
	.button_text{
		padding: 10px 0px;
		height: 100%;
		flex:  0 0 auto;
		font-size: 16px;
		border-bottom: 2px solid #ffffff;
	}

	.menu-bar button.active .button_text {
	  border-bottom: 2px solid #000000;
	}

	.content-box {
	  margin-top: 10px;
	}

	.Posts-content,
	.Media-content {
	  background-color: #f9f9f9;
	  border-radius: 8px;
	}
</style>
